var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from "aurelia-framework";
import { LotteryClientService } from "../../../../services/modules/lottery-client.service";
import { OperatorClientService } from "../../../../services/modules/operator-client.service";
import { NotificationClientService, NotificationType } from "../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
var InsuranceDataHandler = /** @class */ (function () {
    function InsuranceDataHandler(lotteriesClientService, operatorService, notificationService, i18N) {
        this.lotteriesClientService = lotteriesClientService;
        this.operatorService = operatorService;
        this.notificationService = notificationService;
        this.i18N = i18N;
        this.isDataLoaded = false;
        this.isDataLoading = false;
    }
    InsuranceDataHandler.prototype.loadInsuranceData = function (item) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.isDataLoaded) {
                resolve(_this.response);
            }
            else {
                _this.isDataLoading = true;
                var request = {};
                if ('brandId' in item) {
                    request.brandId = item.brandId;
                }
                else {
                    request.operatorId = item.operatorId;
                }
                _this.lotteriesClientService.getLotteriesInsuranceInfo(request)
                    // first we want to get the insurers lookup since we need it for some calculations 
                    .then(function (response) {
                    _this.isDataLoading = false;
                    if (response.lotteries) {
                        if ('brandId' in item) {
                            _this.operatorPoliciesApplied = response.operatorPolicies;
                            _this.lotteries = response.lotteries;
                        }
                        else if ('operatorId' in item) {
                            _this.lotteries = response.lotteries;
                        }
                    }
                    _this.response = response;
                    _this.isDataLoaded = true;
                    resolve(response);
                }).catch(function (e) {
                    _this.isDataLoading = false;
                    _this.notificationService.show(_this.i18N.tr('error-text') + "!", "Error loading lotteries linked to entity", NotificationType.Error);
                    reject(e);
                });
            }
        });
    };
    InsuranceDataHandler = __decorate([
        autoinject,
        transient() // this is used to load the insurance data required for calculations only once 
        ,
        __metadata("design:paramtypes", [LotteryClientService, OperatorClientService,
            NotificationClientService, I18N])
    ], InsuranceDataHandler);
    return InsuranceDataHandler;
}());
export { InsuranceDataHandler };
